import React from 'react';
// Constants
import {
  CompanyName,
  CompanyTagLine,
  FULL_BUSINESS_URL,
  KeywordsPages,
} from '../../utils/constants/Constants';
import { ABOUT_PAGE_URL, HOME_PAGE_URL } from '../../utils/constants/Routes';
// Data
import {
  AboutPageAdditionalMeta,
  AboutPageStructuredData,
} from '../../utils/data/MetaData';
// Components
import Navbar from '../../components/nav/Navbar';
import { HelmetItem } from '../../components/utils/HelmetItem';
import AboutPageMainContainer from '../../components/about/AboutPageMainContainer';
// Utils
import { buildBreadcrumbLd } from '../../utils/seo/breadcrumbs';
import FAQSchema from '../../utils/seo/FAQSchema';
import { aboutPageFaqItems } from '../../utils/data/faqSchemas';

function AboutPage() {
    const breadcrumbLd = buildBreadcrumbLd({
    baseUrl: FULL_BUSINESS_URL,
    items: [
      { label: 'Home', href: HOME_PAGE_URL },
      { label: 'About', href: ABOUT_PAGE_URL },
    ],
  });

  return (
    <>
      {/* Tab Data */}
      <HelmetItem
        PageName='About Me'
        desc={`Step into the world of ${CompanyName}, where indulgence, power, and submission collide. Explore My expertise, desires, and the experiences that await you.`}
        keywords={KeywordsPages}
        additionalMeta={AboutPageAdditionalMeta}
        structuredData={[AboutPageStructuredData, breadcrumbLd]}
        canonicalPath={ABOUT_PAGE_URL}
      />

      {/* Page */}
      <div className='grid min-h-screen w-full overflow-hidden font-poppins bg-colour2 dark:bg-colour2 text-colour1 dark:text-colour1'>
        <div className='grid min-h-screen'>
          {/* Navigation */}
          <Navbar />

          {/* Header */}
          <header className='pt-24 px-8 lg:container lg:mx-auto lg:px-24'>
            <h1
              aria-label={`Biography of ${CompanyName}`}
              className='text-center font-titleFont text-6xl lg:text-6xl tracking-widest'
            >
              About {CompanyName}
            </h1>
            <div className='mx-auto grid justify-center'>
              <h2 className='text-xl xs:text-2xl mt-1 sm:text-3xl md:text-4xl lg:text-4xl lg:py-2 text-center'>
                {CompanyTagLine}
              </h2>
            </div>
          </header>

          {/* Main page content */}
          <AboutPageMainContainer />
        </div>

        {/* FAQ JSON-LD */}
        <FAQSchema items={aboutPageFaqItems} />
      </div>
    </>
  );
}

export default AboutPage;
